import axios from "axios";
import {
  PRODUCT_AVAILABILITY,
  GET_BUSINESS_LOCATION,
  GET_PREPARATION_TIME,
  GET_MENUS,
  PRODUCT,
  CASHREGISTER,
  PRODUCT_VARIATION,
  GET_PRODUCTS_BY_MENU,
  GET_MENUS_BY_ID,
  ADD_TO_CART,
  OUTLATES,
  ORDER,
  TAX,
  RE_ORDERS,
  ORDERS,
  ORDER_HISTORY,
  CATEGORY,
  REGISTER,
  CLEAR_STATE,
  PAYMENT,
  DINE_IN_DETAIL,
  DINE_IN_ORDER,
  GET_ERRORS,
  TRACK_ORDER,
  PLACE_ORDER_PRODUCT,
  LOADING,
  SET_STRIPE_LALAMOVE_KEY,
  GET_STATUS_DELIVERY_STORE,
  CHECK_OUT_PRODUCT,
  GET_CURRENT_OUTLET,
  TOTAL_ORDERS_LOADER_START,
  SET_TOTAL_ORDERS,
  PRODUCT_COMBO
} from "./types";
import { setLoading, setPaginationLoading } from "./commonActions";
import { getError } from "./errorActions";

export const getProductsAvailability = (cdata) => async (dispatch) => {
  try {
    if (!Array.isArray(cdata) || cdata.length === 0) {
      return { status: false, data: [] };
    }
    const products = cdata.map(item => {
      let selectedModifiers = [];

      if (item.variation_id) {
        selectedModifiers = String(item.variation_id)
          .split(",")
          .map(v => ({ id: Number(v.trim()) }));
      }

      if (item.selectedModifiers && item.selectedModifiers.length > 0) {
        selectedModifiers = item.selectedModifiers.map(mod => ({
          id: Number(mod.id || mod)
        }));
      }

      return {
        name: item.product_name,
        product_id: item.product_id,
        localProduct: { selectedModifiers }
      };
    });

    const payload = {
      user_id: localStorage.user_id,
      business_id: localStorage.business_id,
      business_location_id: localStorage.location_id,
      order_platform: "foodDelivery",
      location_id: localStorage.location_id,
      terminal_id: localStorage.terminal_id,
      platform: "foodDelivery",
      token: localStorage.token,
      products
    };

    const res = await axios.post("/get_products_availability", payload);

    dispatch({
      type: PRODUCT_AVAILABILITY,
      payload: Array.isArray(res.data?.data) ? res.data.data : []
    });

    return res.data;

  } catch (err) {
    dispatch(getError(err));
    return null;
  }
};

export const getCategories = () => (dispatch) => {
  let data = {
    business_id: localStorage.business_id,
    business_location_id: localStorage.location_id,
    service_tax_flag: '1',
  }

  dispatch(setLoading());
  axios
    .post("/get_all_categories_do", data)
    .then((res) => {
      const applyInclusiveGST = res.data?.tax.find(t => t.name === "GST")?.apply_inclusive_gst ?? false;
      localStorage.setItem("apply_inclusive_gst", applyInclusiveGST);
      dispatch({ type: CATEGORY, payload: res.data.categories });
    }
    )
    .catch((err) => {
      dispatch(sendError(err))
    });

}

export const getPreparationTime = () => (dispatch) => {
  let business_id = localStorage.getItem('business_id');
  let location_id = localStorage.getItem('location_id');
  if (business_id && location_id) {
    let dataObj = {
      business_id: localStorage.business_id,
      location_id: localStorage.location_id,
    }
    dispatch(setLoading());
    axios.post("check_qr_pickup_preparation_time", dataObj).then((response) => {
      dispatch({
        type: GET_PREPARATION_TIME,
        payload: response.data
      })
    })
  } else {
    return
  }
}

export const getBusinessLocation = () => (dispatch) => {

  dispatch(setLoading());
  axios.post("get_business_location_for_web", { business_location_id: localStorage.location_id }).then((response) => {
    dispatch({
      type: GET_BUSINESS_LOCATION,
      payload: response.data
    })
  })

}

export const getStatusDeliveryStore = (data) => (dispatch) => {
  dispatch(setLoading());
  axios.post("/check_status_delivery_store", {
    "location_id": data.location_id
  }).then((response) => {
    dispatch({
      type: GET_STATUS_DELIVERY_STORE,
      payload: response.data
    })
  }).catch((err) => {
    dispatch(getError(err))
  })
}


export const getProducts = (page = 1, limit = 10, isPagination = false) => (dispatch) => {
  let data = {
    business_id: localStorage.business_id,
    business_location_id: localStorage.location_id,
    category_id: "0",
    page,
    limit,
    platform: "foodDelivery",
  };
  dispatch(isPagination ? setPaginationLoading() : setLoading());
  return axios
    .post("/v1/get_category_products_do", data)
    .then((response) => {
      const { items = [] } = response.data || {};
      const filteredProducts = items.filter(
        (product) =>
          !(Number(product.not_for_selling) === 1 || Number(product?.not_for_pickup_delivery) === 1)
      );

      dispatch({
        type: PRODUCT,
        payload: filteredProducts,
      });
      return filteredProducts;
    })
    .catch((err) => {
      dispatch(getError(err));
      throw err;
    });
};
export const getProductWithFilter = (page = 1, limit = 10, category_id = "0", search = "", searchBy = "category", isPagination = false) => (dispatch) => {
  const trimmedKeyword = (search || "").trim();
  let data = {
    business_id: localStorage.business_id,
    business_location_id: localStorage.location_id,
    searchBy,
    category_id: category_id || "0",
    searchKeyword: trimmedKeyword,
    page,
    limit,
  };

  dispatch(isPagination ? setPaginationLoading() : setLoading());

  return axios
    .post("/v1/get_category_products_search_do", data)
    
    .then((response) => {
      const { items = [] } = response.data || {};

      const filteredProducts = items.filter(
        (product) =>
          !(Number(product.not_for_selling) === 1 || Number(product?.not_for_pickup_delivery) === 1)
      );

      dispatch({
        type: PRODUCT,
        payload: filteredProducts, // same action type as getProducts
      });

      return filteredProducts;
    })
    .catch((err) => {
      dispatch(getError(err));
      throw err;
    });
};

export const checkCashRegister = () => (dispatch) => {
  let data = {
    location_id: localStorage.location_id
  }
  dispatch(setLoading());
  return axios
    .post("/rapyd/checkcashregister", data)
    .then((response) => {
      dispatch({
        type: CASHREGISTER,
        payload: response.data,
      })
    })
    .catch((err) => {
      dispatch(getError(err))
    });
}

export const getStripeAndLalamoveKey = () => (dispatch) => {
  let data = {
    params: {
      business_id: localStorage.business_id,
      location_id: localStorage.location_id
    }
  }
  dispatch(setLoading());
  axios
    .get("/get_stripe_and_lalamove_key", data)
    .then((response) => {
      dispatch({
        type: SET_STRIPE_LALAMOVE_KEY,
        payload: response.data,
      })
      return response.data;
    })
    .catch((err) => dispatch(getError(err)));
}

export const submitPayment = (data) => (dispatch) => {
  dispatch(setLoading());
  axios
    .post("/save_pickup_delivery", data)
    .then((res) => {
      if (res.data?.errorMessage) {
        dispatch({
          type: GET_ERRORS,
          payload: res.data?.errorMessage,
        });
        alert(res.data?.errorMessage);
      }
      else {
        dispatch({
          type: PAYMENT,
          payload: res,
        })
      }
    }
    )
    .catch((err) => {
      dispatch(getError(err));
      if (err.errorMessage) {
        alert(err.errorMessage);
      }
    });
};

export const clearPayment = () => (dispatch) => {
  dispatch({
    type: PLACE_ORDER_PRODUCT,
    payload: null
  })


  dispatch({
    type: PAYMENT,
    payload: null,
  });
};

export const ClearState = () => (dispatch) => {
  dispatch({
    type: CLEAR_STATE,
  });
};

export const Signup = (data) => (dispatch) => {
  dispatch(setLoading());
  axios
    .post("/register", data)
    .then((res) =>
      dispatch({
        type: REGISTER,
        payload: res.data,
      })
    )
    .catch((err) => dispatch(getError(err)));
};

export const Reorder = (id) => (dispatch) => {
  dispatch(setLoading());
  axios
    .get("/orders/reorder/" + id)
    .then((res) => {
      dispatch({
        type: RE_ORDERS,
        payload: res.data.data.original ? res.data.data.original : null,
      });
    })
    .catch((err) => dispatch(getError(err)));
};

export const MyOrders = () => (dispatch) => {
  dispatch(setLoading());
  axios
    .post("/track_order_history",
      {
        'business_id': localStorage.business_id,
        'location_id': localStorage.location_id,
        'contact_id': localStorage.headers != undefined ? (JSON.parse(localStorage.headers)?.data?.user?.contact_id) : 0
      }
    )
    .then((res) => {
      dispatch({
        type: ORDERS,
        payload: res.data,
      });
    })
    .catch((err) => dispatch(getError(err)));
};
export const SingleOrder = (id) => (dispatch) => {
  dispatch(setLoading());
  // axios
  //   .get("/orders/" + id)
  //   .then((res) => {
  //     dispatch({
  //       type: ORDER,
  //       payload: res.data,
  //     });
  //   })
  //   .catch((err) => dispatch(getError(err)));

  var cart_data = [];

  if (localStorage.serviceFee) {
    cart_data = JSON.parse(localStorage.serviceFee)[0];
  }

  dispatch({
    type: ORDER,
    payload: {
      'data': cart_data
    },
  });
};

export const placeOrder = (data) => (dispatch) => {
  dispatch(setLoading());
  dispatch({
    type: ORDER,
    payload: data,
  });
  // axios
  //   .post("/orders", data)
  //   .then((res) => {
  //     dispatch({
  //       type: ORDER,
  //       payload: res.data,
  //     });
  //   })
  //   .catch((err) => dispatch(getError(err)));
};

export const getOutlates = () => (dispatch) => {
  try {
    let businessId = localStorage.getItem('business_id')
    if (businessId) {
      dispatch(setLoading());
      axios
        .post("/find_pickup_store", {
          'business_id': businessId
        })
        .then((res) => {
          dispatch({
            type: OUTLATES,
            payload: res.data,
          });
        })
        .catch((err) => dispatch(getError(err)));
    } else {
      return
    }
  } catch (err) {
    console.log(err);
  }
};

export const checkOutProduct = (products) => (dispatch) => {
  try {
    dispatch({
      type: CHECK_OUT_PRODUCT,
      payload: products,
    });
  } catch (err) {
    console.log(err);
  }
};
// export const cartUpdate = (id, data) => (dispatch) => {
//   dispatch(setLoading());

//   axios
//     .put("/cart/" + id, data)
//     .then((res) => {
//       dispatch({
//         type: ADD_TO_CART,
//         payload: res.data.data.original ? res.data.data.original : null,
//       });
//     })
//     .catch((err) => dispatch(getError(err)));
// };

// export const mycart = () => (dispatch) => {
//   dispatch(setLoading());
//   axios
//     .get("/cart")
//     .then((res) => {
//       dispatch({
//         type: ADD_TO_CART,
//         payload: res.data,
//       });
//     })
//     .catch((err) => dispatch(getError(err)));
// };

export const clearCart = () => (dispatch) => {
  dispatch(setLoading());
  dispatch({
    type: ADD_TO_CART,
    payload: null,
  });

  // dispatch(setLoading());

  // axios
  //   .delete("/cart/clear")
  //   .then((res) => {
  //     dispatch({
  //       type: ADD_TO_CART,
  //       payload: res.data,
  //     });
  //   })
  //   .catch((err) => dispatch(getError(err)));
};

// export const clearCartSingle = (cartId) => (dispatch) => {
//   dispatch(setLoading());

//   axios
//     .delete("/cart/" + cartId)
//     .then((res) => {
//       dispatch({
//         type: ADD_TO_CART,
//         payload: res.data,
//       });
//     })
//     .catch((err) => dispatch(getError(err)));
// };
export const cartLocal = (data) => (dispatch) => {
  dispatch(setLoading());
  dispatch({
    type: ADD_TO_CART,
    payload: data,
  });
  // axios
  //   .post("/cart", data)
  //   .then((res) => {
  //     dispatch({
  //       type: ADD_TO_CART,
  //       payload: res.data,
  //     });
  //   })
  //   .catch((err) => dispatch(getError(err)));

}
// export const addTocart = (data) => (dispatch) => {
//   dispatch(setLoading());
//   console.log("HDUDHUHDUUDHU djdjsi")
//   axios
//     .post("/cart", data)
//     .then((res) => {
//       {console.log("HDUDHUHDUUDHU djdjsi")
//       dispatch({
//         type: ADD_TO_CART,
//         payload: res.data.data ? res.data.data : null,
//       });}

//     })
//     .catch((err) => dispatch(getError(err)));
// };

export const getProductsByCategory = (categoryID) => (dispatch) => {
  dispatch(setLoading());
  axios
    .get(`/menus/${categoryID}`)
    .then((res) =>
      dispatch({
        type: GET_PRODUCTS_BY_MENU,
        payload: res.data,
      })
    )
    .catch((err) => dispatch(getError(err)));
};
export const getMenubyId = (menuID) => (dispatch) => {
  dispatch(setLoading());
  axios
    .get(`/menus/${menuID}`)
    .then((res) =>
      dispatch({
        type: GET_MENUS_BY_ID,
        payload: res.data,
      })
    )
    .catch((err) => dispatch(getError(err)));
};

export const getMenus = () => (dispatch) => {
  dispatch(setLoading());
  return axios
    .get(`/menus`)
    .then((res) => {
      dispatch({
        type: GET_MENUS,
        payload: res.data,
      });
    })
    .catch((err) => dispatch(getError(err)));
};

export const getProductVariation = (product_id) => (dispatch) => {
  let data = {
    business_id: localStorage.business_id,
    user_id: localStorage.headers != undefined ? (JSON.parse(localStorage.headers)?.data?.user) : 0,
    product_id: product_id,
    location_id: localStorage.getItem('location_id')
  }
  dispatch(setLoading());
  axios
    .post("/get_product_modifier_do", data)
    .then((response) => {
      const variations = response.data || [];
      const filteredProducts = variations.filter(
        (e) => e.not_for_pickup_delivery === 0
      );
      dispatch({
        type: PRODUCT_VARIATION,
        payload: filteredProducts,
      })
    }


    )
    .catch((err) => dispatch(getError(err)));
}

export const getTaxes = () => (dispatch) => {
  try {
    let business_id = localStorage.getItem('business_id');
    let location_id = localStorage.getItem('location_id');
    if (business_id && location_id) {
      let data = {
        business_id: localStorage.business_id,
        business_location_id: localStorage.location_id,
        service_tax_flag: '1',
      }
      dispatch(setLoading());
      axios
        .post("/get_all_categories_do", data)
        .then((response) => {
          dispatch({
            type: TAX,
            payload: response.data.tax,
          })
        }

        )
        .catch((err) => dispatch(getError(err)));
    } else {
      return
    }
  } catch (err) {
    console.log(err)
  }

}

export const submitOrder = (data) => (dispatch) => {
  dispatch(setLoading());
  axios
    .post("/save_digital_ordering", data)
    .then((response) =>
      dispatch({
        type: DINE_IN_ORDER,
        payload: response.data,
      })
    )
    .catch((err) => dispatch(getError(err)));
}

export const updateOrder = (data) => (dispatch) => {
  dispatch(setLoading());
  axios
    .post("/update_digital_ordering", data)
    .then((response) =>
      dispatch({
        type: DINE_IN_ORDER,
        payload: response.data,
      })
    )
    .catch((err) => dispatch(getError(err)));
}

export const orderHistory = () => (dispatch) => {
  let data = {
    business_id: localStorage.business_id,
    location_id: localStorage.location_id,
    contact_id: localStorage.headers != undefined ? (JSON.parse(localStorage.headers)?.data?.user?.contact_id) : 0
  }
  dispatch(setLoading());
  axios
    .post("/track_order_history", data)
    .then((response) =>
      dispatch({
        type: ORDER_HISTORY,
        payload: response.data.sells,
      })
    )
    .catch((err) => dispatch(getError(err)));
}
export const trackOrder = (page = 1, limit = 5, searchValue = "", load = true) => (dispatch) => {
  const headers = localStorage.getItem("headers");
  const userId = headers ? JSON.parse(headers)?.data?.user?.contact_id : null;

  const offset = (page - 1) * limit;

  let data = {
    business_id: localStorage.getItem("business_id"),
    location_id: localStorage.getItem("location_id"),
    contact_id: userId,
    page: page,
    offset: offset,
    limit: limit,
  };

  if (searchValue) {
    data.search = searchValue;
  }

  dispatch({
    type: TOTAL_ORDERS_LOADER_START,
    loader: true
  });

  // ✅ Return axios to allow .then() in component
  return axios.post("/track_order", data).then((response) => {



    dispatch({
      type: TRACK_ORDER,
      payload: response.data.sells,
      loading: false
    });

    if (response.data.total !== undefined) {
      dispatch({
        type: SET_TOTAL_ORDERS,
        payload: response.data.total,
        loader: false
      });
    }
    return response; // 👈 makes .then() in component work
  }).catch((err) => {
    dispatch(getError(err));
    throw err; // 👈 allows .catch() in component
  })
}

export const sendError = (error) => {
  return {
    type: GET_ERRORS,
    payload: error,
  };
};

export const placeDeliveryOrder = (data) => dispatch => {
  dispatch({
    type: LOADING
  })
  axios.post("/order/place", data).then((response) => {
    dispatch({
      type: PLACE_ORDER_PRODUCT,
      payload: response
    })
  }).catch((error) => {
    dispatch(getError(error))
  })
}

export const callCheckPickupDelivery = async (data) => {
  try {
    const response = await axios.post("/check_pickup_delivery", data);
    return response.data; // return result so caller can use it
  } catch (error) {
    throw error;
  }
};

export const getCurrentOutlet = (data) => dispatch => {
  try {
    dispatch({
      type: GET_CURRENT_OUTLET,
      payload: data
    });
  } catch (error) {
    throw error;
  }
}

export const fetchComboProducts = (product_id) => (dispatch) => {
  let data = {
    business_id: localStorage.business_id,
    combo_base_product_id: product_id,
    business_location_id: localStorage.getItem('location_id'),
    platform: "foodDelivery",
  }
  dispatch(setLoading());
  axios
    .post("/get_combo_products_do", data)
    .then((response) => {
      const res = response.data || [];
      dispatch({
        type: PRODUCT_COMBO,
        payload: res,
      })
    })
    .catch((err) => dispatch(getError(err)));
}

